export const PERIOD_MODE_DAILY = 'PERIOD_MODE_DAILY';
export const PERIOD_MODE_HOURLY = 'PERIOD_MODE_HOURLY';
export const PERIOD_MODE_MONTHLY = 'PERIOD_MODE_MONTHLY';

export const PERIOD_CHIP_COLOR = {
  [PERIOD_MODE_HOURLY]: 'green darken-1',
  [PERIOD_MODE_DAILY]: 'blue darken-2',
  [PERIOD_MODE_MONTHLY]: 'purple darken-1',
};
